import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  state() {
    return {
      userProfiles: [],
      // userProfiles: [
      //   {
      //     userId: 'RfmrECFf1rdPhkqvMWvlJaf3LB53',
      //     userName: 'test',
      //     email: 'test@test.com',
      //     isAdmin: false,
      //     dateAdded: new Date,
      //   },
      //   {
      //     userId: 'KWEroUllekRTdN7crbUqQjPgpa63',
      //     userName: 'phlepper',
      //     email: 'phlepper@gmail.com',
      //     isAdmin: true,
      //     dateAdded: new Date,
      //   }
      // ],
      currentUser: {
        userId: null,
        userName: null,
        email: null,
        isAdmin: false,
        dateAdded: null,
      }
    };
  },
  mutations,
  actions,
  getters,
};